import Vue from "vue";
import axios from "axios";
import App from "./app.vue";
import store from "./store";
import router from "./router";
import VNotifications from "vue-notification";
import VClickOutside from "v-click-outside";
import VScrollLock from "v-scroll-lock";
import { Alert, Icon } from "ant-design-vue";
import "ant-design-vue/lib/alert/style/css";
import "ant-design-vue/lib/icon/style/css";
import "@components";
import "@styles/index.scss";
import "@utils/extenders/error-handler";

// Set baseURL for axios
if (window.location.origin.includes("test.patentrenewal.com")) {
  axios.defaults.baseURL = "https://team42apiusertest.herokuapp.com/middletier";
} else {
  axios.defaults.baseURL =
    process.env.NODE_ENV === "development"
      ? `${process.env.VUE_APP_API_URL_DEV}`
      : `${process.env.VUE_APP_API_URL}`;
}

Vue.use(VNotifications);
Vue.use(VClickOutside);
Vue.use(VScrollLock);
Vue.use(Alert);
Vue.use(Icon);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
